import { withInstall } from '../utils';
import _Image from './Image';
export var Image = withInstall(_Image);
export default Image;